// Accordion "+" Icon change on PDP
document.addEventListener('DOMContentLoaded', () => {
  const parentContainer = document.getElementById('ProductInfo-template--25272535253283__main');
  if (!parentContainer) return;

  const details = parentContainer.querySelector('.product__accordion details');
  if (!details) return;

  const summary = details.querySelector('summary');
  const svg = summary.querySelector('svg.icon-caret');
  if (svg) {
    svg.remove(); 
  }

  // Add custom styles via JS to inject CSS for the plus/minus
  const styleId = 'custom-accordion-plus-style';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      #ProductInfo-template--25272535253283__main .product__accordion summary {
        position: relative;
      }
      #ProductInfo-template--25272535253283__main .product__accordion summary::after {
        content: '+';
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 3rem;
        color: currentColor;
        width: 1em;
        height: 1em;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.3s ease;
      }
      #ProductInfo-template--25272535253283__main .product__accordion details[open] summary::after {
        content: '−';
        transform: translateY(-50%) rotate(0deg);
      }
    `;
    document.head.appendChild(style);
  }

  // Ensure the position is applied
  summary.style.position = 'relative';
  summary.style.paddingRight = '2rem';

  // Optional: Add ARIA or classes if needed, but native <details> handles toggle
});

      const swiperContainer = document.querySelector(".GetSocial_swiper");
      const dragIcon = document.querySelector(".dragIcon");

      // Hide initially
      dragIcon.style.opacity = "0";
      dragIcon.style.transition = "opacity 0.3s ease";

      swiperContainer.addEventListener("mouseenter", () => {
        dragIcon.style.opacity = "1";
      });

      swiperContainer.addEventListener("mousemove", (e) => {
        const rect = swiperContainer.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        // move icon with cursor (slightly delayed for smoothness)
        dragIcon.style.transition = "transform 0.05s linear";
        dragIcon.style.transform = `translate(${x - 20}px, ${y - 20}px)`;
      });

      swiperContainer.addEventListener("mouseleave", () => {
        dragIcon.style.opacity = "0";
      });

      const swiperGetSocial = new Swiper(".GetSocial_swiper", {
        loop: true, 
        slidesPerView: 1.3, 
        spaceBetween: 20, 
        speed: 2000,
        effect: "slide",
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false,
        // },
        pagination: {
          el: ".long_lasting_pagination",
          type: "progressbar", 
        }, 
        breakpoints: {
          0: {
            slidesPerView: 1.1,
            spaceBetween: 20, 
          },
          768: {
            slidesPerView: 2.1,
            spaceBetween: 20, 
          },
          1199: {
            slidesPerView: 3.3,
            spaceBetween: 20, 
          },
        },
      });

      document.addEventListener('DOMContentLoaded', function() {
        // Target the summary element (hamburger/close toggle)
        const menuSummary = document.querySelector('.header__icon--summary');
        
        if (menuSummary) {
          menuSummary.addEventListener('click', function(e) {
           
            const svgs = this.querySelectorAll('svg');
            const clickedElement = e.target;
            
           
            let isCloseIcon = false;
            if (svgs.length >= 2) {
              isCloseIcon = svgs[1].contains(clickedElement);
            }
            
            if (isCloseIcon) {
              // Close all mega menus
              const allMegaMenus = document.querySelectorAll('.mega-menu.active');
              allMegaMenus.forEach(menu => {
                menu.classList.remove('active');
              });
              
              // Remove active from all trigger links
              const allTriggerLinks = document.querySelectorAll('a[href^="#"].active');
              allTriggerLinks.forEach(link => {
                link.classList.remove('active');
              });
              
              // Remove active from all menu panels
              document.querySelectorAll('.menu-panel-1, .menu-panel-2, .menu-panel-3').forEach(panel => {
                panel.classList.remove('active');
              });
              
              // Hide all panel menus
              document.querySelectorAll('.menu-panel-2 [data-value], .menu-panel-3 [data-value]').forEach(menu => {
                menu.classList.add('hidden');
              });
              
              // Remove active from all links inside panels
              document.querySelectorAll('.has-icon.active').forEach(link => {
                link.classList.remove('active');
              });
              
              // Close any open accordions
              document.querySelectorAll('.accordion-toggle.active').forEach(acc => {
                acc.classList.remove('active');
              });
              
              document.querySelectorAll('.submenu.open').forEach(submenu => {
                submenu.classList.remove('open');
                submenu.style.maxHeight = '0px';
              });
            }
          });
        }
      });